import React from "react";
import Preloader from "../helper/Preloader";
import { useNavigate, useSearchParams } from "react-router-dom";

import HeaderTwo from "../components/HeaderTwo";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import TextInput from "../components/TextInput";

import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleError } from "../utils/functions";
import SubmitButton from "../components/SubmitButton";
import axiosInstance from "../config/axios.config";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const schema = Yup.object().shape({
  password: Yup.string()
    .required("Password is Required")
    .matches(/^(?=.*[a-z])/, "Must Contain One Lowercase Character")
    .matches(/^(?=.*[A-Z])/, "Must Contain One Uppercase Character")
    .matches(/^(?=.*[0-9])/, "Must Contain One Number Character")
    .matches(/^(?=.*[!@#$%^&*])/, "Must Contain One Special Case Character")
    .min(8, "Password must be at least 8 characters long"),
  cPassword: Yup.string()
    .required("Confirm Password is Required")
    .oneOf([Yup.ref("password"), null], "Passwords Must Match"),
});

const UserPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { t } = useTranslation();

  const {
    handleSubmit,
    register,
    formState: { isSubmitting, errors },
  } = useForm({ resolver: yupResolver(schema), mode: "all" });

  const onSubmit = async (data) => {
    try {
      const { data: res } = await axiosInstance.post("/user/update-password", { ...data, token });
      if (!res.error) {
        toast.success(res.message);
        navigate("/user-login");
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      <section className="account py-80">
        <div className="container">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row justify-content-center align-items-center">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body py-30 px-30">
                    <h3 className="my-30 text-center">{t("password.title")}</h3>
                    <div className="mb-24">
                      <TextInput
                        name={"password"}
                        placeholder={t("enterPassword")}
                        isRequired
                        label={t("password.password")}
                        type={"password"}
                        hasicon
                        register={register}
                        error={errors.password}
                      />
                      <TextInput
                        name={"cPassword"}
                        placeholder={t("password.confirmPasswordPlaceholder")}
                        isRequired
                        label={t("password.confirmPassword")}
                        type={"password"}
                        hasicon
                        register={register}
                        error={errors.cPassword}
                      />
                    </div>

                    <div className="mt-30 text-center">
                      <SubmitButton isSubmitting={isSubmitting}>
                        {t("password.updateButton")}
                      </SubmitButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default UserPassword;
